import { PostStatusEnum } from 'modules/community/enums/post-status-enum'

export const PostStatusLocoKey = {
  [PostStatusEnum.Approved]: 'post.status.approved',
  [PostStatusEnum.Declined]: 'post.status.declined',
  [PostStatusEnum.Pending]: 'post.status.pending',
  [PostStatusEnum.Scheduled]: 'post.status.scheduled',
} as const satisfies Record<PostStatusEnum, string>

export const ACTIVITY_CLEANUP_PERIOD_DURATION = 7
